import { Typography } from '@mui/material';
import { useFormHeaderTitle } from './FormHeader.hooks';
import { HeaderContainer } from './FormHeader.styles';

const FormHeader = () => {
  'use memo';
  const title = useFormHeaderTitle();

  return (
    <HeaderContainer>
      <Typography variant="h5">{title}</Typography>
    </HeaderContainer>
  );
};

export default FormHeader;
